var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"helper"},[_c('img',{staticClass:"helper__icon",attrs:{"src":'/img/icons/helper-'+_vm.type+'.svg'}}),_c('span',{class:'helper__text helper__text--'+_vm.type},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }